import React from 'react';
import moment from 'moment';

export const Footer = () => {
  const endYear = moment.utc().year();
  return (
    <div className='footer'>
      <p>Exelot © 2016-{endYear}</p>
    </div>
  );
};
